<template>
  <div class="dof-row">
    <slot></slot>
  </div>
</template>

<script>
import { mixParent } from '../utils/mix-parent.js'

export default {
  mixins: [mixParent('dof-row')],
  props: {
    gap: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped>
.dof-row {
  flex-direction: row;
  flex-wrap: nowrap;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// index.vue?ab69f902